// 난수 생성
export function guid() {
  function _p8(s: boolean) {
    const p = (Math.random().toString(16) + "000000000").substr(2, 8)
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p
  }
  return _p8(false) + _p8(true) + _p8(true) + _p8(false)
}

// 차량번호 정규식
export function regexCarNumber(val: string) {
  const reg = /^[0-9]{2,3}[가-힣]{1}[0-9]{4}$|^[가-힣]{2,3}[0-9]{1,2}[가-힣]{1}[0-9]{4}$|^[가-힣]{2}[0-9]{6}$/.test(val)
  return reg
}

export function makeACall(tel: string) {
  document.location.href = `tel:${tel}`
}
